/* eslint-disable react/prop-types */
import React from "react";
import styled from "styled-components";
import { Select } from "antd";
import { noop } from "lodash";
import { countries } from "@/utils/countries";
import { NoResults } from "../customs/NoResults";
import { SvgArrowDown } from "@/assets/icons";
import { RATypography } from "../customs";

export const RASelectCountry = ({
	value = {},
	onChange = noop,
	title = "",
	error = "",
	"data-testid": dataTestId = null,
	...props
}) => {
	const handleFilterOptions = (inputValue, option) =>
		option.short_code?.toLowerCase()?.includes(inputValue?.toLowerCase()) ||
		option.english_name?.toLowerCase()?.includes(inputValue?.toLowerCase()) ||
		option.native_name?.toLowerCase()?.includes(inputValue?.toLowerCase()) ||
		option.calling_code?.toLowerCase()?.includes(inputValue?.toLowerCase());

	return (
		<Wrapper>
			{title && (
				<WrapperTitle>
					<RATypography color="#595959" variant="sub-heading4">
						{title}
					</RATypography>
				</WrapperTitle>
			)}
			<StyledSelect
				showSearch
				options={countries}
				size="large"
				placeholder="Select Country"
				fieldNames={{
					label: "english_name",
					value: "short_code",
					options: "options",
				}}
				suffixIcon={<SvgArrowDown />}
				notFoundContent={<NoResults description="Oops! You don't have any data" />}
				dropdownRender={(originNode) => <DropdownRender>{originNode}</DropdownRender>}
				dropdownMatchSelectWidth={false}
				value={value?.short_code}
				onChange={(_, option) => onChange(option)}
				filterOption={handleFilterOptions}
				data-testid={dataTestId}
				{...props}
			/>
			{!!error && (
				<RATypography variant="body3" color="#BF1A2F" top="4px">
					{error}
				</RATypography>
			)}
		</Wrapper>
	);
};

const Wrapper = styled.div``;
const StyledSelect = styled(Select)`
	width: 100%;
	&.ant-select .ant-select-selector {
		font-family: DMSans-Regular;
		font-size: 14px !important;
		height: 44px;
		padding: 0 20px !important;
		border-radius: 12px;
	}
	.ant-select-selection-item {
		display: flex;
		align-items: center;
		color: #65686f;
		font-size: 14px !important;
		font-family: "DM Sans";
	}
	.ant-select-selection-search,
	.ant-select-selection-placeholder {
		display: flex;
		align-items: center;
		inset-inline-start: 20px !important;
		inset-inline-end: 40px !important;
		color: #a8a8a8;
	}
	.ant-select-arrow {
		inset-inline-end: 20px;
	}
	&.ant-select {
		height: 44px;
	}
	&.ant-select-sm {
		height: 32px;
	}
	&.ant-select-lg {
		height: 50px;
	}
	&.ant-select-lg .ant-select-selector {
		height: 50px !important;
	}
	&.ant-select-sm .ant-select-selector {
		height: 32px !important;
	}
	.ant-select-selection-placeholder {
		color: #a8a8a8;
		font-family: "DM Sans";
		font-size: 14px;
	}
`;
const DropdownRender = styled.div`
	.ant-select-item {
		height: 50px;
		padding: 0 20px;
		color: #65686f;
		font-family: "DM Sans";
		font-size: 14px;
		display: flex;
		align-items: center;
	}
`;
const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;
